import { blue, common } from '@mui/material/colors';
import { BoardColumnEntity, MoveCardEventParams } from 'components/shared/Board/types';

import { DealPipelineListItem } from '../types';

export function generateBoardColumns(
  groupedVOs: {
    groupName: string;
    list: DealPipelineListItem[];
  }[]
) {
  const res: BoardColumnEntity<DealPipelineListItem>[] = [];

  groupedVOs.forEach(({ groupName, list }) => {
    res.push({
      id: groupName,
      cards: list,
      title: groupName,
      metaData: {
        isSupportDAD: !['LOST', 'WON'].includes(groupName),
        nameColor: !['LOST', 'WON'].includes(groupName) ? common.black : blue[600],
      },
    });
  });

  return res;
}

export function buildOptimisticColumns<T>(
  columns: BoardColumnEntity<T>[],
  { fromColumnId, toColumnId, itemIndex }: MoveCardEventParams
): BoardColumnEntity<T>[] {
  const newCols = structuredClone(columns);
  const fromCol = newCols.find(({ id }) => id === fromColumnId)!;
  const toCol = newCols.find(({ id }) => id === toColumnId)!;
  const [moved] = fromCol.cards.splice(itemIndex, 1);

  if (moved && typeof moved === 'object' && 'modifiedDateTime' in moved) {
    (moved as Record<string, unknown>).modifiedDateTime = new Date().toISOString();
  }

  toCol.cards.unshift(moved);
  return newCols;
}
